<style lang="less">
/*@import "../../style/common.less";*/
@import "../../style/color.less";
@import "../../style/button.css";
/*.el-table {*/
/*background: linear-gradient(to right, #092a9c, #0c5692) !important ;*/
/*}*/
.el-dialog__header {
	//background: linear-gradient(to right, #092a9c, #0c5692) !important ;
	//color: white;
}

.el-dialog__body {
	//background: linear-gradient(to right, #092a9c, #0c5692) !important ;
}

/*.iot-form-actions-div {*/
	/*background: linear-gradient(to right, #092a9c, #0c5692);*/
/*}*/

/*.el-dialog__title{*/
/*//	color: white;*/
/*}*/
</style>
<style lang="less">
	.input-class{
		.el-input__inner {
			width: 140px;
			height: 40px;
			border: 1px solid deepskyblue;
		}
	}
	.input-class2{
		.el-input__inner {
			width: 210px;
			height: 40px;
			border: 1px solid deepskyblue;
		}
	}
	.dialog-input-text .el-input__inner {
		//width: 75px;
		width: 100%;
		height: 40px;
		border: 1px solid deepskyblue;
	}
	//数字靠右
	.dialog-input-text2 .el-input__inner {
		//width: 75px;
		width: 100%;
		height: 40px;
		border: 1px solid deepskyblue;
		text-align: right;
	}
	.el-checkbox{
		.el-checkbox__inner{
			border: 1px solid deepskyblue;
		}
		/*.el-input__inner {
			width: 140px;
			height: 40px;
			border: 1px solid deepskyblue;
		}*/
	}
	.el-checkbox__inner{

	}
	.fcc_bgp{
		background: url("../../img/footer_logo_fcc.svg")no-repeat;
		background-position: 90%;
	}
	.formTable {
		margin-top: 10px;
		//width: 1300px;
		height: 100px;
		margin-bottom: 10px;
		/*background: url("../../img/fccLOGO.png")no-repeat;*/
		/*background-position: 50%;*/
	}
	.like_instNo {
		float: left;
		width: 300px;
		height: 50px;
	}
	span.query-title-span {
		display: inline-block;
		width: 90px;
		font-size: 14px;
		font-weight: 700;
		text-align: right;
		margin-right: 20px;
		color: black;
	}
</style>

<template>
	<div class="iot-vue-container">
		<div class="vue-main">
			<div class="list-tb-container">
				<!--操作功能区 -->
				<!--<div class="actions-div  margin-bottom-10">-->
					<!--<div class="btns-div margin-top-10">-->
						<!--<Button type="primary" class="button button-glow button-rounded button-raised button-primary"-->
								<!--@click="addRow"><i class="fa fa-plus"></i> 新增-->
						<!--</Button>-->
						<!--<Button type="primary" class="button button-glow button-rounded button-action"-->
								<!--@click="checkForSave"><i class="fa fa-save"></i> 保存-->
						<!--</Button>-->
						<!--<Button class="button button-glow button-rounded button-royal"-->
								<!--@click="dialogVisibleReset = true"><i-->
							<!--class="fa fa-cog fa-fw"></i>密码重置-->
						<!--</Button>-->
						<!--<el-dialog-->
							<!--title="保存"-->
							<!--:visible.sync="dialogVisibleSave"-->
							<!--width="30%">-->
							<!--<span>确认保存吗</span>-->
							<!--<span slot="footer">-->
								<!--<el-button @click="dialogVisibleSave = false">取 消</el-button>-->
								<!--<el-button type="primary" @click="checkedSave">确 定</el-button>-->
					  		<!--</span>-->
						<!--</el-dialog>-->
						<!--<el-dialog-->
							<!--title="密码重置"-->
							<!--:visible.sync="dialogVisibleReset"-->
							<!--width="30%">-->
							<!--<span>确认重置吗</span>-->
							<!--<span slot="footer">-->
								<!--<el-button @click="dialogVisibleReset = false">取 消</el-button>-->
								<!--<el-button type="primary" @click="submitPwdReset">确 定</el-button>-->
					  		<!--</span>-->
						<!--</el-dialog>-->
					<!--</div>-->
					<!--<div class="search-div margin-top-10">-->
						<!--&lt;!&ndash;搜索区 &ndash;&gt;-->
						<!--&lt;!&ndash;<el-input type="text" id="like_lotNo" style="width: 150px" placeholder="请输入用户名查询"-->
								  <!--v-model="searchVal"/>&ndash;&gt;-->
						<!--<el-input placeholder="请输入用户名查询" class="vue-main-search-input" v-model="searchVal">-->
							<!--<el-button type="primary" class="iot-btn-search info-color"-->
									<!--v-loading.fullscreen.lock="fullscreenLoading" icon="ios-search" slot="append"-->
									<!--@click="getList('query')">搜索-->
							<!--</el-button>-->
						<!--</el-input>-->
					<!--</div>-->
				<!--</div>-->
				<div class="fcc_bgp">
				<div class="formTable">
					<div class="like_instNo">
						<span class="query-title-span">账号</span>
						<el-input type="text" style="width: 150px" v-model="queryParam.userAcc"/>
					</div>
					<div class="like_instNo">
						<span class="query-title-span">用户名</span>
						<el-input type="text" style="width: 150px" v-model="queryParam.userName"/>
					</div>
					<!--				</div>-->
					<!--				<div class="firstRow">-->
				</div>
				<!--操作功能区 -->
				<div class="actions-div  margin-bottom-10">
					<div class="btns-div margin-top-10">

						<Button type="primary" class="button button-glow button-rounded button-raised button-primary"
						@click="addRow"><i class="fa fa-plus"></i> 新增
						</Button>
						<Button type="primary" class="button button-glow button-rounded button-action"
						@click="checkForSave"><i class="fa fa-save"></i> 保存
						</Button>
						<Button class="button button-glow button-rounded button-royal"
						@click="dialogVisibleReset = true"><i
						class="fa fa-cog fa-fw"></i>密码重置
						</Button>
						<el-dialog
						title="保存"
						:visible.sync="dialogVisibleSave"
						width="30%">
						<span>确认保存吗</span>
						<span slot="footer">
						<el-button @click="dialogVisibleSave = false">取 消</el-button>
						<el-button type="primary" @click="checkedSave">确 定</el-button>
						</span>
						</el-dialog>
						<el-dialog
						title="密码重置"
						:visible.sync="dialogVisibleReset"
						width="30%">
						<span>确认重置吗</span>
						<span slot="footer">
						<el-button @click="dialogVisibleReset = false">取 消</el-button>
						<el-button type="primary" @click="submitPwdReset">确 定</el-button>
						</span>
						</el-dialog>

					</div>
					<div class="pull-right margin-top-10">
						<!--搜索区 -->
						<Button type="primary" class="button button-glow button-rounded button-royal"
								v-loading.fullscreen.lock="fullscreenLoading" icon="ios-search" slot="append"
								@click="getList('query')">检索
						</Button>
					</div>
				</div>
				</div>
				<!--表格区-->
				<el-table :data="listData"    :row-style="rowStyle"
						  :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor"  @selection-change="handleSelection"  ref="multipleTable" border row-key="id"
						  :height="600">
					<el-table-column type="selection" align="center" width="40">
					</el-table-column>
					<!--<el-table-column type="index" align="center" width="55">
					</el-table-column>-->
					<el-table-column label="操作" min-width="110" align="center">
						<template slot-scope="scope">
							<!--							<Button class="button1 button-glow button-border button-rounded button-royal"-->
							<!--									@click="toEdit(scope.row.userId)"><i class="fa fa-pencil fa-fw"></i>&nbsp;编辑-->
							<!--							</Button>-->
							<Button class="button button-glow button-rounded button-caution"
									@click="toDelete(scope.row.userId)"><i class="fa fa-trash-o fa-fw"></i> 删除
							</Button>
						</template>
					</el-table-column>
					<el-table-column prop="userAcc" label="*账号" min-width="150">
						<template slot-scope="scope">
							<el-input v-if="scope.row.userId==null" size="small" type="text" v-model="scope.row.userAcc" @focus="onFocus()"
									  align="center" class="dialog-input-text" maxlength="20"></el-input>
							<span v-else align="center" style="white-space:pre">{{ scope.row.userAcc }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="userName" label="*用户名" min-width="170">
						<template slot-scope="scope">
							<el-input size="small" type="text" v-model="scope.row.userName" @focus="onFocus()"
									  align="center" class="dialog-input-text" maxlength="40"></el-input>
						</template>
					</el-table-column>
					<!--					<el-table-column prop="zyCd" label="工号" min-width="170">-->
					<!--					</el-table-column>-->
					<el-table-column prop="userPassword" label="*密码" min-width="130">
						<template slot-scope="scope">
							<el-input v-if="scope.row.userId==null" size="small" type="password" @focus="onFocus()"
									  v-model="scope.row.userPassword"
									  align="center" class="dialog-input-text" maxlength="40"></el-input>
							<span v-else align="center" style="white-space:pre">●●●●●●</span>
						</template>
					</el-table-column>
					<el-table-column prop="roleName" label="*角色名" min-width="170">
						<template slot-scope="scope">

							<el-select  filterable  v-model="scope.row.roleName" class="dialog-input-text" @change="roleChange($event,scope.row)" @focus="onFocus()">
								<el-option
									v-for="item in roleList"
									:key="item.roleId"
									:label="item.roleName"
									:value="{code:item.roleId,name:item.roleName}">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="userTypeNm" label="*用户类型" min-width="150">
						<template slot-scope="scope">
							<el-select  filterable  v-model="scope.row.userTypeNm" class="dialog-input-text" @change="userTpChange($event,scope.row)" @focus="onFocus()">
								<el-option
									v-for="item in userTypeist"
									:key="item.userType"
									:label="item.userTypeNm"
									:value="{code:item.userType,name:item.userTypeNm}">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="userType" label="用户类型cd" v-if="show" min-width="120">
					</el-table-column>
					<el-table-column prop="spplCd" label="供应商代码" min-width="170">
						<template slot-scope="scope">
							<el-input size="small" type="text" v-model="scope.row.spplCd" @focus="onFocus()"
									  align="center" class="dialog-input-text" maxlength="40"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="spplName" label="供应商名称" min-width="170">
						<template slot-scope="scope">
							<el-input size="small" type="text" v-model="scope.row.spplName" @focus="onFocus()"
									  align="center" class="dialog-input-text" maxlength="40"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="plantNo" label="工厂" min-width="170" v-if="show">
						<template slot-scope="scope">
							<el-input size="small" type="text" v-model="scope.row.plantNo" value="SDN" align="center" @focus="onFocus()"
									  class="dialog-input-text"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="lastModifiedByName" label="更新者" min-width="120">
					</el-table-column>
					<el-table-column prop="lastModifiedWhen"  label="更新时间" min-width="200">
					</el-table-column>
				</el-table>
				<!--表格区-->
				<!--分页区 -->
				<el-pagination class="iot-pagination" v-show="pageParams.total>0" :current-page="pageParams.currentPage"
							   :page-sizes="sysCfg.pageParams.opts" @size-change="handleSizeChange"
							   @current-change="handlePageChange" :page-size="pageParams.pageSize"
							   :layout="sysCfg.pageParams.pageLayout" :total="pageParams.total">
				</el-pagination>


				<!--				<el-dialog title="密码重置" :visible.sync="dialogVisible" width="600px">-->
				<!--					<div class="dialog-overflow iot-form">-->
				<!--						<Form ref="pwdFrom" :model="pwdInfo" :rules="ruleValidate">-->
				<!--							<FormItem label="新密码" prop="userPassword">-->
				<!--								<Input v-model="pwdInfo.userPassword" type="password"></Input>-->
				<!--							</FormItem>-->
				<!--							<FormItem label="确认密码" prop="userPasswordCp">-->
				<!--								<Input v-model="pwdInfo.userPasswordCp" type="password"></Input>-->
				<!--							</FormItem>-->
				<!--							<FormItem class="iot-form-actions-div check-child-submit">-->
				<!--								<Button type="primary"-->
				<!--										class="button button-glow button-rounded button-border button-action"-->
				<!--										@click="submitPwdReset('pwdFrom')"><i class="fa fa-save"></i>&nbsp;&nbsp;提交-->
				<!--								</Button>-->
				<!--								<Button type="ghost"-->
				<!--										class="button button-glow button-rounded button-border button-action"-->
				<!--										@click="cancelPwdReset"><i class="fa fa-close"></i>&nbsp;&nbsp;取消-->
				<!--								</Button>-->
				<!--							</FormItem>-->
				<!--						</Form>-->
				<!--					</div>-->
				<!--				</el-dialog>-->

			</div>
		</div>
	</div>
</template>
<script>
import config from '@/config/config.js';
import {mapActions} from "vuex";

export default {
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.pwdInfo.userPassword) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			pageTitle: '用户列表',
			sysCfg: config,
			listData: [],
			roleList: [],
			userTypeist: [
				{
					userType:1,
					userTypeNm:'自公司'
				},
				{
					userType:2,
					userTypeNm:'供应商'
				},
			],
			plantList: [],
			pageParams: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			queryParam: {
				pageNum: 0,
				pageSize: 10
			},
			searchVal: '',
			detailRouter: 'userDetail',
			fullscreenLoading: false,
			selections: [],
			pwdInfo: {},
			dialogVisible: false,
			ruleValidate: {
				userPassword: [
					{required: true, message: '请输入密码', trigger: 'blur'}
				],
				userPasswordCp: [
					{required: true, validator: validatePass, trigger: 'blur'}
				],
			},
			dialogVisibleSave: false,
			dialogVisibleReset: false,
			show: false,
			updateFlg:false,
		};
	},
	methods: {
		...mapActions("tab", ["reflush"]),
		init() {
			// 数据初始化
			this.searchVal = '';
			// 角色
			this.roleList = this.$job.getRoleList(this);
			// 工厂
			this.plantList = this.$job.getPlantList(this);
			this.getList('init');
			this.updateFlg=false;
		},
		onFocus() {
			this.updateFlg=true;
		},
		// 获取用户列表
		getList(val) {
			if (val !== undefined) {
				this.pageParams.currentPage = 1;
			}
			var _this = this;
			_this.initQueryParam();
			this.fullscreenLoading = true;
			_this.$httpUtil.ajaxGet(this, _this.$api.user.list, _this.queryParam, function (response) {
				_this.listData = response.data.data.content;
				// 获取前一页
				if (_this.listData.length === 0 && _this.pageParams.currentPage > 1) {
					_this.pageParams.currentPage--;
					_this.getList();
				} else {
					_this.pageParams.total = response.data.data.totalElements;
					_this.fullscreenLoading = false;
				}
			});
			_this.updateFlg=false;
		},
		// 初始化查询参数
		initQueryParam() {
			// if (!this.$util.isEmpty(this.searchVal)) {
			// 	this.queryParam.userName = this.searchVal;
			// } else {
			// 	delete this.queryParam.userName;
			// }
			this.queryParam.pageNum = this.pageParams.currentPage - 1 >= 0 ? this.pageParams.currentPage - 1 : 0;
			this.queryParam.pageSize = this.pageParams.pageSize;
		},
		handlePageChange(val) {
			this.pageParams.currentPage = val;
			this.getList();
		},
		handleSizeChange(val) { // 条数变更回调
			this.pageParams.pageSize = val;
			this.getList();
		},
		//角色更改事件
		roleChange(val,row) {
			row.roleId=val.code;
			row.roleName=val.name;
		},
		//用户类型更改事件
		userTpChange(val,row) {
			row.userType=val.code;
			row.userTypeNm=val.name;
		},
		/*//保存选中结果
		handleSelectionChange(val) {
			this.multipleSelection = val;
			//console.log(this.multipleSelection,'multipleSelection');
		},*/
		rowStyle({row, rowIndex}){
			let arr = this.selections;
			if (arr!=null&&arr.length>0) {
				for(let i = 0; i < arr.length; i++){
					if( row.userId == arr[i].userId){
						return { "background-color": "rgba(0, 250, 154, 0.75)" };
					}
				}
			}
		},
		// 新增
		// toAdd() {
		// 	var _this = this;
		// 	this.$router.push({
		// 		name: _this.detailRouter,
		// 	})
		// },
		//表格新增行
		/*addRow() {
			let list = {
				userAcc: null,
				userName: null,
				userPassword: null,
				roleId: null,
				// roleName: null,
				plantNo: 'SDN',
				deptId: 'jqxc2gabbjgvlayveydiogqht4',

			}
			this.listData.push(list);

		},*/
		//表格新增行
		addRow() {
			let _this = this;
			let selected=this.selections;
			console.log(selected.length,'1111');
			if (selected == null || selected == '') {
				let list = {
					id: null,
					userAcc: null,
					userName: null,
					userPassword: null,
					roleId: null,
					roleName: null,
					userTypeNm:null,
					userType:null,
					spplCd:null,
					spplName:null,
					plantNo: 'CFF',
					deptId: 'jqxc2gabbjgvlayveydiogqht4',
				};
				this.listData.push(list);
				// 复制行设为选中
				this.$refs.multipleTable.toggleRowSelection(this.listData[this.listData.length-1], true);
			} else {
				if (selected.length > 1) {
					//_this.$util.error('只能选中一条数据复制新增');
					_this.$util.error(msgCfg.WEV6022W);
					return;
				} else {
					let selectedIndex=0;
					this.listData.forEach((val, index)=> {
						if (val==selected[0]) {
							selectedIndex=index;
							//console.log(selectedIndex,'selectedIndex1111');
						}
					});
					let list = {
						id: null,
						userAcc: this.listData[selectedIndex].userAcc,
						userName: this.listData[selectedIndex].userName,
						userPassword: this.listData[selectedIndex].userPassword,
						roleId: this.listData[selectedIndex].roleId,
						roleName: this.listData[selectedIndex].roleName,
						userTypeNm:this.listData[selectedIndex].userTypeNm,
						userType:this.listData[selectedIndex].userType,
						spplCd:this.listData[selectedIndex].spplCd,
						spplName:this.listData[selectedIndex].spplName,
						plantNo: 'CFF',
						deptId: 'jqxc2gabbjgvlayveydiogqht4',
					};
					this.listData.splice(selectedIndex+1, 0,JSON.parse(JSON.stringify(list)));
					// 原选中行设为取消选中
					this.$refs.multipleTable.toggleRowSelection(selected[0], false);
					// 复制行设为选中
					this.$refs.multipleTable.toggleRowSelection(this.listData[selectedIndex+1], true);
				}
			}
		},
		// 选中保存
		checkForSave() {
			let _this = this;
			let selected = this.selections;
			let flag = false;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('未选中任何数据');
				return;
			}
			selected.some(function (item) {
				if (item.userAcc == null || item.userAcc == undefined || item.userAcc == '') {
					_this.$util.error('请输入账号');
					return flag = true;
				}
				if (item.userName == null || item.userName == undefined || item.userName == '') {
					_this.$util.error('请输入用户名');
					return flag = true;
				}
				if (item.userId == null || item.userId == undefined || item.userId == '') {
					if (item.userPassword == null || item.userPassword == undefined || item.userPassword == '') {
						_this.$util.error('请输入密码');
						return flag = true;
					}
				}
				if (item.roleId == null || item.roleId == undefined || item.roleId == '') {
					_this.$util.error('请选择角色');
					return flag = true;
				}
				if (item.userType == null || item.userType == undefined || item.userType == '') {
					_this.$util.error('请选择用户类型');
					return flag = true;
				}
				if (item.spplCd == null || item.spplCd == undefined || item.spplCd == '') {
					if(item.userType=='2') {
						_this.$util.error('请设置供应商代码');
						return flag = true;
					}
				}else {
					if(item.userType=='1') {
						_this.$util.error('自公司用户不可设置供应商代码');
						return flag = true;
					}
				}
				if (item.spplName == null || item.spplName == undefined || item.spplName == '') {
					if(item.userType=='2') {
						_this.$util.error('请设置供应商名称');
						return flag = true;
					}
				}else {
					if(item.userType=='1') {
						_this.$util.error('自公司用户不可设置供应商名称');
						return flag = true;
					}
				}
			});
			if (flag) {
				return;
			}
			selected.some(function (item1) {
				let count = 0;
				_this.listData.forEach((item2, i) => {
					if (item1.userAcc == item2.userAcc) {
						count++;
					}
				})
				if (count > 1) {
					return flag = true;
				}
			})
			if (flag) {
				_this.$util.error('当前页存在重复数据，保存失败。');
				return;
			}
			this.dialogVisibleSave = true;
			return;
		},
		checkedSave() {
			let _this = this;
			let selected = this.selections;
			_this.$httpUtil.ajaxPut(this, _this.$api.user.checkedSave, selected, function (res) {
				if (res.data.data.status == 200) {
					_this.$util.success(res.data.data.message);
					_this.getList();
				} else {
					_this.$util.error2(res.data.data.message);
				}
			});
			this.dialogVisibleSave = false;
		},
		// 修改
		// toEdit(id) {
		// 	this.$store.commit("tab/DelCache", "userDetail");
		// 	var _this = this;
		// 	this.$router.push({
		// 		name: _this.detailRouter,
		// 		params: {
		// 			id: id
		// 		}
		// 	})
		// },
		// 删除
		toDelete(id) {
			let _this = this;
			let url = this.$api.user.list + '/' + id;
			if (id != null && id != undefined && id != '') {
				this.$job.delFun(_this, url, function () {
					_this.getList();
				});
			} else {
				_this.getList();
			}
		},
		//密码变更
		toUpdatePwd() {
			if (this.checkSelect()) {
				if (this.selections.length > 1) {
					this.selectOne();
					return false;
				}
				// 操作id
				this.dialogVisible = true;
			}
		},
		handlePwdChange() {

		},
		// submitPwdReset(formName) {
		// 	var _this = this;
		// 	this.$refs[formName].validate((valid) => {
		// 		if (valid) {
		// 			var tempObj = _this.selections[0];
		// 			tempObj.userPassword = _this.pwdInfo.userPassword;
		// 			_this.$httpUtil.ajaxPatch(_this, _this.$api.user.list, tempObj, function (response) {
		// 				_this.$util.success('修改成功');
		// 				_this.cancelPwdReset();
		// 				_this.getList();
		// 			});
		// 		}
		// 	});
		// },
		// 提交密码重置
		submitPwdReset() {
			let _this = this;
			let selected = this.selections;
			if (selected == null || selected == undefined || selected == '') {
				_this.$util.error('未选中任何数据');
				this.dialogVisibleReset = false;
				return;
			}
			_this.$httpUtil.ajaxPut(this, _this.$api.user.resetPassword, selected, function (res) {
				if (res.data.data.status == 200) {
					_this.$util.success2(res.data.data.message);
					_this.getList();
				} else {
					_this.$util.error2(res.data.data.message);
				}
			});
			this.dialogVisibleReset = false;
		},
		// 取消
		cancelPwdReset() {
			this.pwdInfo = {};
			this.dialogVisible = false;
		},
		//2020-6-17 MODIFY BY DUAN MCF风格式样修改
		// //设置表格行的样式
		// tableRowStyle({row,column,rowIndex,columnIndex}){
		// 	if((rowIndex % 2) == 1){
		// 		return "background-color: #0c5692 !important; font-size:13px; color:#fff;padding: 7px 0;"
		// 	}else{
		// 		return "background-color: greenyellow !important; font-size:13px;padding: 7px 0;"
		// 	}
		// },
		// //设置表头行的样式
		// tableHeaderColor({row,column,rowIndex,columnIndex}){
		// 	return 'background-color: #092a9c; font-wight:500;font-size:15px;text-align:center;color:white;padding: 7px 0;'
		// },
		//设置表格行的样式
		tableRowStyle({row,column,rowIndex,columnIndex}){
			return "border: 1px solid black !important;color:black;font-size:16px;padding: 7px 0;"
		},
		//设置表头行的样式
		tableHeaderColor({row,column,rowIndex,columnIndex}){
			return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #CCCCCC !important;color:black;padding: 7px 0;'
		},
		// 单选判断
		handleSelection(selection) {
			this.selections = selection;
		},
		selectOne() {
			this.$util.error(config.msg.selectOne);
		},
		selectNeed() {
			this.$util.error(config.msg.selectNeed);
		},
		checkSelect() {
			if (this.selections.length < 1) {
				this.selectNeed();
				return false;
			}
			return true;
		},
	},
	mounted() {
		this.init();
	},
	watch: {}
};
</script>



// WEBPACK FOOTER //
// src/views/user/List.vue